import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

export const StyledContainerGrid = styled(Grid)`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const StyledButtonContainerGrid = styled(Grid)`
  margin-top: ${({ theme }) => theme.spacing(2)};
`;
